import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import BrandDetail from "@/pages/BrandDetail";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <div className="grain" aria-hidden="true" />
        <BrowserRouter>
          <SmoothScroll>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/brands/:slug" element={<BrandDetail />} />
            </Routes>
            <Footer />
          </SmoothScroll>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
